import * as React from 'react'; 
import { Translation, DataItem } from '../../models/models';
import { BurgerIcon } from '../../components/ui/BurgerIcon/BurgerIcon';
import { Menu } from '../../components/ui/Menu/Menu';
import { SocialButtons } from '../../components/ui/SocialButtons/SocialButtons';
import { RES_URL, IS_FIREFOX, IS_EMBED } from '../../config';
import { ImgContainer } from '../../components/ui/ImgContainer/ImgContainer';
import VerticalAligner from '../../components/ui/VerticalAligner/VerticalAligner';
import { ImgNumDisplay } from '../../components/ui/ImgNumDisplay/ImgNumDisplay';
import { LANG } from '../../constants';


export interface MainPageProps{
    className?: string;
    locale: Translation;
    dataset: DataItem[];
}

export interface MainPageState{
    isMenuOpen: boolean;
    currentImgIdx: number;
    isAltImgShown: boolean;
    burgerIconOpen: boolean;
}

declare var jQuery, dataLayer;

export class MainPage extends React.Component<MainPageProps, MainPageState>{
    el: HTMLDivElement; 
    imgEl: ImgContainer;

    constructor(p:MainPageProps){
        super(p);
        this.state = {
            isMenuOpen: false,
            currentImgIdx: 0,
            isAltImgShown: true,
            burgerIconOpen: false
        }
    }

    componentDidMount() {
        window.addEventListener("keydown", this.keyPressed);
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.keyPressed);
    }

    keyPressed = (e: KeyboardEvent) => {
        e.preventDefault();
        if(e.keyCode === 37) {
            this.prevImg();
        } else if(e.keyCode === 39) {
            this.nextImg();
        }
    }

    toggleMenu = () => {
        this.setState({
            burgerIconOpen: !this.state.burgerIconOpen
        }, () => {
            setTimeout(() => {
                this.setState({ isMenuOpen: !this.state.isMenuOpen })
            }, 400);
        })
        
    }

    setImgByIdx = (idx:number) => {
        this.setState({ 
            currentImgIdx: idx,
            isAltImgShown: true 
        });
    }

    nextImg = () => {
        let newIdx = this.state.currentImgIdx + 1;
        dataLayer.push({
            event: "clickEvent",
            clickEvent: "next-"+ newIdx
          });
        if(this.state.currentImgIdx < this.props.dataset.length - 1) {
            if(IS_FIREFOX) {
                this.hideImg();
                setTimeout(() => {
                    this.setState({ 
                        currentImgIdx: this.state.currentImgIdx + 1, 
                        isAltImgShown: true
                    }, () => this.showImg());    
                }, 350);
            } else {
                this.setState({ 
                    currentImgIdx: this.state.currentImgIdx + 1, 
                    isAltImgShown: true
                });
            }
        } else {
            if(this.state.currentImgIdx === this.props.dataset.length - 1) {
                if(IS_FIREFOX) {
                    this.hideImg();
                    setTimeout(() => {
                        this.setState({ 
                            currentImgIdx: 0, 
                            isAltImgShown: true
                        }, () => this.showImg());
                    }, 350);
                } else {
                    this.setState({ 
                        currentImgIdx: 0, 
                        isAltImgShown: true
                    });
                }
            }
        }
    }

    prevImg = () => {
        let newIdx = this.state.currentImgIdx - 1;
        dataLayer.push({
            event: "clickEvent",
            clickEvent: "prev-"+newIdx
          });
        if(this.state.currentImgIdx > 0) {
            if(IS_FIREFOX) {
                this.hideImg();
                setTimeout(() => {
                    this.setState({ 
                        currentImgIdx: this.state.currentImgIdx - 1,
                        isAltImgShown: true
                    }, () => this.showImg())
                }, 350);
            } else {
                this.setState({ 
                    currentImgIdx: this.state.currentImgIdx - 1,
                    isAltImgShown: true
                })
            }
        } else {
            if(this.state.currentImgIdx === 0) {
                if(IS_FIREFOX) {
                    this.hideImg();
                    setTimeout(() => {
                        this.setState({ 
                            currentImgIdx: this.props.dataset.length - 1,
                            isAltImgShown: true
                        }, () => this.showImg()) 
                    }, 350);
                } else {
                    this.setState({ 
                        currentImgIdx: this.props.dataset.length - 1,
                        isAltImgShown: true
                    }) 
                }
            }
        }
    }

    toggleAltImg = () => {
        if(IS_FIREFOX) {
            this.hideImg();
            setTimeout(() => {
                this.setState({ isAltImgShown: !this.state.isAltImgShown }, () => this.showImg()
            )}, 350);
        } else {
            this.setState({ isAltImgShown: !this.state.isAltImgShown })
        }
    }

    hideImg = () => {
        if(this.imgEl.el) {
            this.imgEl.el.classList.add("hidden");
        }
    }

    showImg = () => {
        if(this.imgEl.el) {
            this.imgEl.el.classList.remove("hidden");
        }
    }

    render(){
        let props = this.props, 
            state = this.state,
            cls = this.props.className || "";
        
        const currentImg = props.dataset[state.currentImgIdx];

        return (
            <div className={"main-page " + cls}  ref={e => this.el = e}>
                <BurgerIcon
                    className={(state.isMenuOpen ? "open " : " ") + (state.burgerIconOpen ? "show-x" : "")}
                    onClick={this.toggleMenu}
                >
                </BurgerIcon>
                {/* <div className="main-page__line"></div> */}
                <Menu
                    className={state.isMenuOpen ? "open" : ""}
                    isOpen={state.isMenuOpen}
                    dataset={props.dataset}
                    goToImg={this.setImgByIdx}
                    closeMenu={this.toggleMenu}
                    locale={props.locale}
                    currentImgIdx={state.currentImgIdx}
                >
                </Menu>
                <div className={`main-page__campaign-logo ${LANG}`}>
                    <a href={`${RES_URL}`}>
                        <img src={`${RES_URL}img/${LANG}/campaign-logo.svg`} 
                            alt={props.locale.campaignName}
                            className="campaign-logo"
                        />
                    </a>
                </div>
                <VerticalAligner>
                    <main className="main-page__content">
                        <div className="main-page__img-name">
                            <div className="line"></div>
                            <p className="name">{`${currentImg.name} ${currentImg.year} & 2018`}</p>
                        </div>
                        <ImgContainer
                            ref={e => this.imgEl = e}
                            className={IS_FIREFOX ? "ff" : ""}
                            imgUrl={`${RES_URL}img/${IS_EMBED ? "embed/" : ""}${state.isAltImgShown ? "old" : "new"}/${props.dataset[state.currentImgIdx].imgUrl}.jpg`}
                            alt={props.dataset[state.currentImgIdx].name}
                            next={this.nextImg}
                            prev={this.prevImg}
                        >
                        </ImgContainer>
                        <div className="main-page__prev-next-section">
                            <div className="line"></div>
                            <div className="main-page__arrows">
                                <div className="prev arrow"
                                     onClick={this.prevImg}
                                >
                                    <img src={`${RES_URL}img/icons/chevron.svg`} alt="arrow previous"/>
                                </div>
                                <div className="prev arrow arrow--white"
                                     onClick={this.prevImg}
                                >
                                    <img src={`${RES_URL}img/icons/chevron-wht.svg`} alt="arrow previous" />
                                </div>
                                <ImgNumDisplay
                                    currentImg={this.state.currentImgIdx + 1}
                                    numOfImgs={this.props.dataset.length}
                                >
                                </ImgNumDisplay>
                                <div className="next arrow"
                                     onClick={this.nextImg}
                                >
                                    <img src={`${RES_URL}img/icons/chevron.svg`} alt="arrow next" />
                                </div>
                                <div className="next arrow arrow--white"
                                     onClick={this.nextImg}
                                >
                                    <img src={`${RES_URL}img/icons/chevron-wht.svg`} alt="arrow next"/>
                                </div>
                            </div>
                        </div>
                    </main>
                </VerticalAligner>
                <div className={`main-page__reveal-btn ${LANG}`}
                     onClick={this.toggleAltImg}
                >
                    {
                        LANG === "de"
                        ? <p>{!state.isAltImgShown ? "Vergangenheit" : "Gegenwart"}</p>
                        : <p>{!state.isAltImgShown ? "See past" : "See present"}</p>
                    }
                </div>
                <div className="main-page__social">
                    <SocialButtons
                        locale={props.locale}
                    >
                    </SocialButtons>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/MainPage/MainPage.tsx